module.exports = __webpack_public_path__ + "static/media/prudencia.df04b6d7.svg";